/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {useHistory} from 'react-router-dom'
import ArrowRight from '../../assets/icons/arrow-right.svg'

const Breadcrumb = ({items, current}) => {
    const history = useHistory()

    function breadLink(link) {

        history.push({
            pathname: link, state: null
        });

    }

    return (
        <div className='flex flex-row w-full justify-start pt-4 flex-wrap'>

            <div className='flex items-center mb-2 breadCrumSubMain'>
                {items.map((elem, index) => (<React.Fragment key={elem.link || index}>
                        <button
                            className="font-bold text-14 text-darkGrey cursor-pointer hover:text-primary transition-colors duration-150"
                            onClick={() => {
                                breadLink(elem.link)
                            }}
                        >{elem.title}</button>
                        <img src={ArrowRight} alt='arrow' className='mx-2 md:mx-5 opacity-50' />
                    </React.Fragment>
                ))}
                <p className="font-bold text-14 text-primary">{current}</p>

            </div>

        </div>
    )
}

export default Breadcrumb
